import styled from "styled-components";

export const StyledCard = styled.div`
  border-radius: ${(props) => props.theme.radius.normal};
  box-shadow: ${(props) => props.theme.shadow.default};
  border: 1px solid ${(props) => props.theme.colors.primary.darkest};
  background-color: ${(props) => props.theme.colors.primary.normal};
`;

export const StyledCardHeader = styled.header`
  background-color: ${(props) => props.theme.colors.primary.darkest};
  color: ${(props) => props.theme.colors.on.primary};
  padding: ${(props) => props.theme.spacing.normal};
  border-top-left-radius: ${(props) => props.theme.radius.normal};
  border-top-right-radius: ${(props) => props.theme.radius.normal};

  & h2 {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

export const StyledCardBody = styled.div`
  background-color: ${(props) => props.theme.colors.primary.normal};
  color: ${(props) => props.theme.colors.on.primary};
  padding: ${(props) => props.theme.spacing.normal};
  border-bottom-left-radius: ${(props) => props.theme.radius.normal};
  border-bottom-right-radius: ${(props) => props.theme.radius.normal};

  &:first-child {
    border-top-left-radius: ${(props) => props.theme.radius.normal};
    border-top-right-radius: ${(props) => props.theme.radius.normal};
  }
`;
